// Single source of truth for plan names + display prices.
// Both /upgrade, the homepage, and the onboarding flow must import from here.
// Backend price IDs are in Stripe; this file is for display/marketing only.

export type PlanId = "free" | "analyst" | "institutional";

export interface PlanDisplay {
  id: PlanId;
  name: string;
  monthlyUsd: number;
  annualUsd: number;
  tagline: string;
}

export const PLANS: Record<PlanId, PlanDisplay> = {
  free: {
    id: "free",
    name: "Free",
    monthlyUsd: 0,
    annualUsd: 0,
    tagline: "EURUSD · GBPUSD · USDJPY",
  },
  analyst: {
    id: "analyst",
    name: "Analyst",
    monthlyUsd: 39,
    annualUsd: 390,
    tagline: "All majors + gold · daily Telegram",
  },
  institutional: {
    id: "institutional",
    name: "Institutional",
    monthlyUsd: 99,
    annualUsd: 990,
    tagline: "Full council · priority signals · advanced backtest",
  },
};

export const PLAN_LIST: PlanDisplay[] = [PLANS.free, PLANS.analyst, PLANS.institutional];
